import React from 'react';

import 'assets/scss/_loading.scss';
import { useLoadingState } from 'global/loadingState';
import { usePageLoadingState } from 'global/pageLoadingState';
/**
 * 비동기 및 페이지 로딩 컴포넌트
 */
const Loading = () => {
  /* recoil */
  const { loading } = useLoadingState();
  const { pageLoading } = usePageLoadingState();

  /* view */
  return (
    <>
      {(loading || pageLoading) && (
        <div className="loading-box">
          <div className="loading">
            {new Array(4).fill('').map((value, index) => (
              <div key={`loading${index}`} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Loading;
